import api from "./mosaic-cms-ssr-api";

export const getMosaicCmsData = async function (templateName) {
    try {
        const response = await api.get(`/api/v1/bff-schema/page/page-template/${templateName}`);
        return response.data.data;
    } catch (e) {
        // eslint-disable-next-line no-console
        return { isSSRError: true, error: `Page template SSR error: ${e}` };
    }
};
